"use client";

import type { ImageProps } from "next/image";
import Image from "next/image";
import { useState } from "react";

interface CustomImageProps extends ImageProps {
  alt: string; // Make alt required
}

export default function CustomImage(props: CustomImageProps) {
  // Extract alt and className from props to explicitly set them on the Image component
  const { alt, className = "", onLoad, ...otherProps } = props;
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <Image
      alt={alt}
      className={`transition-opacity duration-1000 ${imageLoaded ? "opacity-100" : "opacity-0"} ${className}`}
      quality={100}
      onLoad={(e) => {
        setImageLoaded(true);
        if (onLoad) onLoad(e);
      }}
      {...otherProps}
    />
  );
}
